import { Link } from 'react-router-dom';

interface Category {
  id: string;
  name: string;
  slug: string;
}

interface CategoryTabsProps {
  categories: Category[];
  activeSlug: string;
}

export default function CategoryTabs({ categories, activeSlug }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
          activeSlug === ''
            ? 'bg-primary-500 text-white'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}